import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { formatTimeAgo } from '@/lib/utils'

interface TimeAgoProps {
  date: Date
  prefix?: string
}

export function TimeAgo({ date, prefix }: TimeAgoProps) {
  const { t } = useTranslation()
  const [, setTick] = useState(0)

  useEffect(() => {
    const getInterval = () => {
      const diffMs = Date.now() - date.getTime()
      // Under 1 minute: tick every second
      if (diffMs < 60_000) return 1_000
      // Under 1 hour: tick every 30 seconds
      if (diffMs < 3_600_000) return 30_000
      // Otherwise: tick every minute
      return 60_000
    }

    let timer: ReturnType<typeof setTimeout>

    const schedule = () => {
      timer = setTimeout(() => {
        setTick((n) => n + 1)
        schedule()
      }, getInterval())
    }

    schedule()
    return () => clearTimeout(timer)
  }, [date])

  const text = formatTimeAgo(date, t)
  return <>{prefix ? `${prefix} ${text}` : text}</>
}
